// Meta (Facebook) Pixel — direct script injection (no npm dependency).
// Defensive: tolerates ad blockers, network failures, and silently no-ops if
// the upstream script can't load — never surfaces a "Script error." to the app.

const PIXEL_ID = '1545009850674181'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

function safeCall(...args: any[]) {
  try {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq(...args)
    }
  } catch {
    // swallow — pixel must never break the app
  }
}

function loadPixelScript(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (window.fbq) return

  // Minimal fbq queue shim — buffers calls until the real script loads.
  const fbqShim: any = function () {
    fbqShim.callMethod
      ? fbqShim.callMethod.apply(fbqShim, arguments)
      : fbqShim.queue.push(arguments)
  }
  window.fbq = fbqShim
  if (!window._fbq) window._fbq = fbqShim
  fbqShim.push = fbqShim
  fbqShim.loaded = true
  fbqShim.version = '2.0'
  fbqShim.queue = []

  const script = document.createElement('script')
  script.async = true
  script.crossOrigin = 'anonymous'
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  // If the script is blocked (ad blocker / network), fail silently — do NOT
  // let the error bubble to window.onerror as "Script error.".
  script.onerror = (e) => {
    try {
      if (e && typeof (e as Event).preventDefault === 'function') {
        ;(e as Event).preventDefault()
      }
    } catch {
      /* noop */
    }
  }
  const first = document.getElementsByTagName('script')[0]
  if (first && first.parentNode) {
    first.parentNode.insertBefore(script, first)
  } else {
    document.head.appendChild(script)
  }
}

export function initPixel() {
  if (initialized) return
  initialized = true

  // Defer to idle / next tick so React render is never blocked by pixel work.
  const start = () => {
    try {
      loadPixelScript()
      safeCall('init', PIXEL_ID)
      safeCall('track', 'PageView')

      // noscript <img> fallback
      const noscript = document.createElement('noscript')
      const img = document.createElement('img')
      img.height = 1
      img.width = 1
      img.style.display = 'none'
      img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
      noscript.appendChild(img)
      document.head.appendChild(noscript)
    } catch {
      // swallow — analytics must never break the page
    }
  }

  if (typeof window === 'undefined') return

  const w = window as any
  if (typeof w.requestIdleCallback === 'function') {
    w.requestIdleCallback(start, { timeout: 2000 })
  } else {
    setTimeout(start, 0)
  }
}

export function trackEvent(event: string, params?: Record<string, unknown>) {
  safeCall('track', event, params)
}

export function trackInitiateCheckout(
  params: { content_name?: string; value?: number; currency?: string } = {},
) {
  trackEvent('InitiateCheckout', {
    currency: 'ARS',
    ...params,
  })
}

export function trackLead(params?: Record<string, unknown>) {
  trackEvent('Lead', params)
}

export function trackViewContent(params?: Record<string, unknown>) {
  trackEvent('ViewContent', params)
}

export function trackPurchase(params: {
  value: number
  currency?: string
  content_name?: string
}) {
  trackEvent('Purchase', {
    currency: 'ARS',
    ...params,
  })
}
